<template>
    <modal name="offline-review-modal" class="offline-review-modal"
           :width="'80%'"
           :height="'80%'"
           @before-close="handlerBeforeClose"
           @before-open="handlerBeforeOpen"
           @opened="handlerOpened"
    >
        <div class="list-content pa15">
            <member-detail-component :memberType="'reviewDetail'" :memberKey="memberKey"></member-detail-component>
            <review-component :reviewType="'list'" :userKey="memberKey"></review-component>
        </div>
    </modal>
</template>

<script>
    import util from "@/mixins/util";
    import ReviewComponent from "@/components/review/ReviewComponent";
    import MemberDetailComponent from "@/components/member/MemberDetailComponent";

    export default {
        name: "OfflineReviewModal",
        mixins: [],
        components: {
            MemberDetailComponent,
            ReviewComponent
        },
        props: {
            memberKey: {default: 0},
        },
        data() {
            return {
            }
        },
        beforeRouterEnter() {},
        created() {
        },
        mounted() {
        },
        beforeDestroy() {
        },
        destroyed() {},
        computed: {
        },
        methods:{
            handlerBeforeOpen(event) {

            },
            handlerOpened() {
            },
            handlerBeforeClose() {
                if(this.$route.path !=  this.$route.fullPath) {
                    this.$router.replace(this.$route.path);
                }
            },
            close(){
                this.$modal.hide('offline-review-modal');
            },

        },
        watch: {

        },
    }
</script>

<style scoped>

</style>
